export default "__VITE_ASSET__lgJtHTDM__"